$(function () {
  $('.accordionSection .accordionItem .title').on('click keydown', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;

    e.preventDefault();
    e.stopPropagation();

    const $button = $(this);
    const $accordionItem = $button.closest('.accordionItem');
    const $container = $accordionItem.closest('.apo-container');
    const $content = $accordionItem.find('.content');

    const isOpen = $accordionItem.hasClass('open');

    $accordionItem.toggleClass('open', !isOpen);
    $accordionItem.toggleClass('closed', isOpen);
    $container.toggleClass('open', !isOpen);
    $container.toggleClass('closed', isOpen);

    $button.attr('aria-expanded', !isOpen);

    if (isOpen) {
      $content.slideUp(300);
    } else {
      $content.slideDown(300);
    }
  });
});
